import { LoggedInUser } from '.';

export interface JitsiState {
  ongoing: boolean;
  joined: boolean;
  left: boolean;
  invitedToExternalConference: boolean;
}

/* ACTIONS */

export enum JitsiActionsKeys {
  START_MEET = 'START_MEET',
  STOP_MEET = 'STOP_MEET',
  JOIN_MEET = 'JOIN_MEET',
  LEAVE_MEET = 'LEAVE_MEET',
  START_EXTERNAL_MEET = 'START_EXTERNAL_MEET',
  RESET_STATE = 'RESET_STATE',
  SOCKET_ON_STARTED_CONFERENCE = 'SOCKET_ON_STARTED_CONFERENCE',
  SOCKET_ON_STOPPED_CONFERENCE = 'SOCKET_ON_STOPPED_CONFERENCE',
  SOCKET_ON_STARTED_EXT_CONFERENCE = 'SOCKET_ON_STARTED_EXT_CONFERENCE',
}

export interface JitsiActionsPayload {
  [JitsiActionsKeys.START_MEET]: void;
  [JitsiActionsKeys.STOP_MEET]: void;
  [JitsiActionsKeys.JOIN_MEET]: void;
  [JitsiActionsKeys.LEAVE_MEET]: void;
  [JitsiActionsKeys.RESET_STATE]: void;
  [JitsiActionsKeys.START_EXTERNAL_MEET]: void;
  [JitsiActionsKeys.SOCKET_ON_STARTED_CONFERENCE]: { session_id: string; user: LoggedInUser };
  [JitsiActionsKeys.SOCKET_ON_STOPPED_CONFERENCE]: { session_id: string; user: LoggedInUser };
  [JitsiActionsKeys.SOCKET_ON_STARTED_EXT_CONFERENCE]: { session_id: string; user: LoggedInUser };
}

/* MUTATIONS */

export enum JitsiMutationsKeys {
  CREATE_MEET = 'CREATE_MEET',
  STOP_MEET = 'STOP_MEET',
  SET_ONGOING_MEET = 'SET_ONGOING_MEET',
  SET_INVITED_TO_EXTERNAL_MEET = 'SET_INVITED_TO_EXTERNAL_MEET',
  JOIN_MEET = 'JOIN_MEET',
  LEAVE_MEET = 'LEAVE_MEET',
  JITSI_RESET_STATE = 'JITSI_RESET_STATE',
}

export interface JitsiMutationsPayload {
  [JitsiMutationsKeys.CREATE_MEET]: void;
  [JitsiMutationsKeys.STOP_MEET]: void;
  [JitsiMutationsKeys.SET_ONGOING_MEET]: boolean;
  [JitsiMutationsKeys.SET_INVITED_TO_EXTERNAL_MEET]: boolean;
  [JitsiMutationsKeys.JOIN_MEET]: void;
  [JitsiMutationsKeys.LEAVE_MEET]: void;
  [JitsiMutationsKeys.JITSI_RESET_STATE]: void;
}

/* GETTERS */

export enum JitsiGettersKeys {
  isMeetOngoing = 'isMeetOngoing',
  isMeetJoined = 'isMeetJoined',
  isMeetLeft = 'isMeetLeft',
  isInvitedToExternalConference = 'isInvitedToExternalConference',
}

export interface JitsiGettersReturns {
  [JitsiGettersKeys.isMeetOngoing]: boolean;
  [JitsiGettersKeys.isMeetJoined]: boolean;
  [JitsiGettersKeys.isMeetLeft]: boolean;
  [JitsiGettersKeys.isInvitedToExternalConference]: boolean;
}
